
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 1.5a3.754 3.754 0 00-3.75 3.75A3.754 3.754 0 009 9a3.754 3.754 0 003.75-3.75A3.754 3.754 0 009 1.5zm0 6c-1.24 0-2.25-1.01-2.25-2.25S7.76 3 9 3s2.25 1.01 2.25 2.25S10.24 7.5 9 7.5zm6.75 8.25V15a5.257 5.257 0 00-5.25-5.25h-3A5.256 5.256 0 002.25 15v.75h1.5V15a3.754 3.754 0 013.75-3.75h3A3.754 3.754 0 0114.25 15v.75h1.5z"}})])
          )
        }
      }
    